<!-- 圆环图 -->
<template>
    <div ref="main" class="sad" style="width: 100%;height: 100%"></div>
</template>
<script setup>
import {ref, onMounted, watch} from "vue";
//  按需引入 echarts
import * as echarts from "echarts";

const main = ref() // 使用ref创建虚拟DOM引用，使用时用main.value
const props = defineProps({
    data: {
        type: Array,
        default: []
    },
})
watch(props, () => {
    init()
})

onMounted(
    () => {
        init()
    }
)

function init() {
    // echarts.init(main.value)
    let myChart = echarts.init(main.value);
    let option = {
        xAxis: {
            type: 'category',
            // boundaryGap: false,
            data: props.data.map(item=>item.name),
            axisLine:{
                show:false
            },
            axisTick: {
                show: false  // 隐藏刻度
            },

        },
        yAxis: {
            name:'单位：亩',
            type: 'value',
            axisTick: {
                show: false  // 隐藏刻度
            },
            axisLine:{
                show:false
            },
            splitLine: {
                show: false
            }
        },
        tooltip: {
            trigger: 'axis',
            formatter: function(params) {
                var name = params[0].name; // 获取数据值
                var value = params[0].value?params[0].value.toLocaleString():params[0].value; // 获取数据值
                var unit = '亩'; // 设置单位
                let content = '<div>' + name;
                content += '<div style="margin-top:5px;display: flex;align-items: center;">' + '<div><span style="margin-right:5px;display: inline-block;width: 10px;height: 10px;border-radius:50%;background: linear-gradient(0deg, #2C5FE1, #76BAFF);"></span></div>' + value + unit + '</div>';
                content += '</div>';
                return content
            }
        },
        grid: {
            left: 60,
            bottom: 30,
            right: 30,
            top: 30,

        },
        series: [
            {
                data: props.data.map(item=>item.value),
                type: 'line',
                lineStyle: {
                    color: '#447FF8' // 设置线的颜色
                },
                itemStyle: {
                    color: '#447FF8' // 设置圆点的颜色
                },
                areaStyle: {
                    color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                            offset: 0, color: 'rgba(68,127,248,0.22)' // 0% 处的颜色
                        }, {
                            offset: 1, color: 'rgba(232,229,229,0)' // 100% 处的颜色
                        }],
                        globalCoord: false // 缺省为 false
                    }
                }
            }
        ]
    };
    myChart.setOption(option)
}

</script>
